import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

interface JsonProps {
  uid: string;
  content?: string;
  iconUrl?: string;
  showRemainingTime: boolean;
  campaign?: {
    code: string;
    startDate?: number;
    endDate?: number;
    url: string;
  };
}
export function createSchaefflerTopBannerComponent(json: string) {
  const data = JSON.parse(json) as JsonProps;
  addBanner(data);

  return null;
}

let externalBannerList: JsonProps[] = [];
const setterList: Dispatch<SetStateAction<JsonProps[]>>[] = [];

const addBanner = (banner: JsonProps) => {
  externalBannerList = [...externalBannerList, banner];
  setterList.forEach((setter) => setter(externalBannerList));
};

export function useSchaefflerTopBannerList() {
  const [bannerList, setBannerList] = useState<JsonProps[]>(() => externalBannerList);

  useEffect(() => {
    setterList.push(setBannerList);
    return () => {
      setterList.splice(setterList.indexOf(setBannerList), 1);
    };
  }, []);

  return bannerList;
}
